<template>
    <div class="realName home_bg">
        <Header></Header>
        <div style="width: 100%;height: 80px;"></div>
        <div class="company_main">
            <div class="wx_box">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
                <div class="wx_main">
                    <div class="top">
                        <div class="wx_title fl">
                            <span>企业认证</span>
                        </div>
                    </div>
                    <div class="form">
                        <div class="item">
                            <div class="label">填写公司名字:</div>
                            <div class="input">
                                <el-form-item label="" prop="truename">
                                <el-input v-model="ruleForm.truename" placeholder="请输入公司真实名称"></el-input>
                                   </el-form-item>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">上传法人身份证:</div>
                            <div class="flies">
                                <div class="flie_fl">
									 <el-form-item label="" prop="law_idcard_zhen">
                                    <el-upload
                                           :action="uploadAction"
                                           :headers="myHeaders"
                                            :on-success="handlePositiveSuccess"
                                            :before-upload="beforePositiveUpload"
                                            :show-file-list="false"
                                            :file-list="positivefileList">
                                        <div class="positive">
                                            <img :src="ruleForm.law_idcard_zhen" v-if="positivefileList.length>0">
                                        </div>
                                    </el-upload>
									 </el-form-item>
                                </div>
                                <div class="flie_fr">
									 <el-form-item label="" prop="law_idcard_fan">
                                    <el-upload
                                            :action="uploadAction"
                                            :headers="myHeaders"
                                            :on-success="handleOtherSideSuccess"
                                            :before-upload="beforeOtherSideUpload"
                                            :show-file-list="false"
                                            :file-list="otherSideList">
                                        <div class="otherSide">
                                            <img :src="ruleForm.law_idcard_fan" v-if="otherSideList.length>0">
                                        </div>
                                    </el-upload>
									 </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">上传营业执照:</div>
                            <div class="flies">
                                <div class="flie_fl">
									 <el-form-item label="" prop="business_license">
                                    <el-upload
                                           :action="uploadAction"
                                           :headers="myHeaders"
                                            :on-success="handleLicenseSuccess"
                                            :before-upload="beforeLicenseUpload"
                                            :show-file-list="false"
                                            :file-list="licenseList">
                                        <div class="face">
                                            <img :src="ruleForm.business_license" v-if="licenseList.length>0">
                                        </div>
                                    </el-upload>
									 </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clause">
                        <h4>法律条款</h4>
                        <div class="msg">
                            {{text}}
                        </div>
						<el-form-item label="" prop="checked">
                        <el-checkbox v-model="ruleForm.checked">已阅</el-checkbox>
						</el-form-item>
                    </div>
                    <div class="btns">
                        <el-button @click="person_company_verfiy('ruleForm')" v-if="is_verify===0">提交资料进行实名认证</el-button>
                        <el-button @click="person_company_verfiy('ruleForm')" v-if="is_verify===1">审核通过，上传资料重新认证</el-button>
						<el-button @click="person_company_verfiy('ruleForm')" v-if="is_verify===2">实名认证失败，上传资料重新认证</el-button>
						<el-button  v-if="is_verify===3">公司实名认证待审核</el-button>
                    </div>
                </div>
				</el-form>
            </div>
        </div>
    </div>
</template>

<script>
	import {getRuleClause,personCompanyVerify,getUserCompanyVerify} from '@/api/api'
	import axios from 'axios';
    import Header from '@/components/Header';
    export default {
        name: "company",
        data(){
            return{
				ruleForm:{
						   truename:'',
						   business_license:'',
						   law_idcard_zhen:'',  
						   law_idcard_fan:'',
						   checked:'',
				},
       uploadAction:axios.defaults.baseURL+"/upload/image",
       myHeaders: {
                authorization: "Bear "+localStorage.getItem("token")
              },
                  text:'',
                positivefileList:[],
                otherSideList:[],
                licenseList:[],
              
				is_verify:0,
				rules: {
							truename: [{
									required: true,
									message: '请输入公司名称',
									trigger: 'blur'
								}
							],
							business_license: [{
									required: true,
									message: '请上传公司营业执照',
									trigger: 'blur'
								}
							],
							law_idcard_zhen: [{
									required: true,
									message: '请输上传身份证正面',
									trigger: 'blur'
								}
							],
							law_idcard_fan: [{
									required: true,
									message: '请上传身份证反面',
									trigger: 'blur'
								}
							],
							checked: [{
									required: true,
									message: '请选择已阅读协议',
									trigger: 'blur'
								}
							]
							
				}
            }
        },
		created(){
			this.get_rule_clause()
		},
		mounted() {
			this.get_user_company_verify();
		},
		
		
        methods:{
			get_rule_clause(){
				getRuleClause().then(resp=>{
					 this.text=resp.content
				})
			},
	       get_user_company_verify(){
				getUserCompanyVerify().then(resp=>{
					
					this.is_verify=resp.is_verify;
					if(resp.is_verify>0)
					 {
					 this.ruleForm=resp.verify
					 this.positivefileList.push({url:resp.law_idcard_zhen})
					  this.otherSideList.push({url:resp.law_idcard_fan})
					  this.licenseList.push({url:resp.business_license})
					 }
				})
			},
			person_company_verfiy(formName){
			 this.$refs[formName].validate((valid) => {
			 	console.log(valid)
			 	if (valid) {
			 		personCompanyVerify(this.ruleForm).then(resp=>{
			 			if(resp.status==1){
							this.$message.success(resp.msg)
							this.get_user_company_verify();
			 			}else{
			 				this.$message.error(resp.msg);
			 			}
			 			}).catch(error=>console.log(error))
			 	} else {
			 		console.log('error submit!!');
			 		return false;
			 	}
			 });
			},
            // 身份证正面上传
            handlePositiveSuccess(res, file) {
                this.positiveUrl = URL.createObjectURL(file.raw);
				this.ruleForm["law_idcard_zhen"]=res.data;
				 this.positivefileList.push(res.data)
            },
            beforePositiveUpload(file) {
              const isJPG = file.type === 'image/jpeg';
                            const isPng = file.type === 'image/png';
                            if (!isJPG && !isPng) {
                                this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
              					return false
                            }else{
              					return true
              				}
            },
            // 身份证fan面上传
            handleOtherSideSuccess(res, file) {
                this.otherSideUrl = URL.createObjectURL(file.raw);
				this.ruleForm["law_idcard_fan"]=res.data;
				 this.otherSideList.push(res.data)
            },
            beforeOtherSideUpload(file) {
                  const isJPG = file.type === 'image/jpeg';
                                const isPng = file.type === 'image/png';
                                if (!isJPG && !isPng) {
                                    this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
                  					return false
                                }else{
                  					return true
                  				}
            },
            // 营业执照
            handleLicenseSuccess(res, file) {
                this.licenseUrl = URL.createObjectURL(file.raw);
				this.ruleForm["business_license"]=res.data;
				 this.licenseList.push(res.data)
            },
            beforeLicenseUpload(file) {
                           const isJPG = file.type === 'image/jpeg';
                            const isPng = file.type === 'image/png';
                            if (!isJPG && !isPng) {
                                this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
              					return false
                            }else{
              					return true
              				}
            },
        },
        components: {
            Header
        }
    }
</script>

<style lang="less">
    .realName{
        .company_main{
            padding: 0 30px 60px 30px;
            .wx_box{
                .wx_main{
                    padding: 10px 0 80px 17px;
                    background:radial-gradient(rgba(19, 62, 173, 0.74),rgba(5, 18, 32, 0.47));
                    background-size: cover;
                    .top{
                        width: 100%;
                        float: left;
                        padding-bottom: 20px;
                    }
                    .form{
                        width: 822px;
                        margin: 0 auto;
                        .label{
                            font-size: 18px;
                            color: #fff;
                            padding: 22px 0 15px 0;
                        }
                        .input{
                            .el-input__inner{
                                background-color: rgba(45, 153, 255, 0.3);
                                border: 0;
                                border-radius: 0;
                                color: #C0C0C0;
                                font-size: 16px;
                            }
                        }
                        .tips{
                            font-size: 14px;
                            color: #858FA9;
                            padding-top: 8px;
                        }
                        .flies{
                            display: flex;
                            justify-content: space-between;
                            flex-wrap: wrap;
                            .flie_fl{
                                width: 384px;
                                height: 263px;
                                .positive{
                                    width: 384px;
                                    height: 263px;
                                    background: url("../../assets/images/home/positive.png") no-repeat;
                                    background-size: cover;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                }
                                .face{
                                    width: 384px;
                                    height: 263px;
                                    background: url("../../assets/images/home/license.png") no-repeat;
                                    background-size: cover;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                }
                                img{
                                    width: 342px;
                                    height: 220px;
                                }
                            }
                            .flie_fr{
                                width: 384px;
                                height: 263px;
                                .otherSide{
                                    width: 384px;
                                    height: 263px;
                                    background: url("../../assets/images/home/otherSide.png") no-repeat;
                                    background-size: cover;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                }
                                img{
                                    width: 342px;
                                    height: 220px;
                                }
                            }
                        }
                    }
                    .btns{
                        width: 100%;
                        text-align: center;
                        padding-top: 75px;
                        .el-button{
                            width: 420px;
                            height: 48px;
                            background: #2D99FF;
                            font-size: 18px;
                            font-weight: 400;
                            color: #fff;
                            border: 0;
                            border-radius: 0;
                        }
                    }
                    .clause{
                        width: 822px;
                        margin: 0 auto;
                        padding-top: 27px;
                        h4{
                            font-size: 18px;
                            font-weight: 400;
                            color: #fff;
                            padding-bottom: 12px;
                        }
                        .msg{
                            font-size: 16px;
                            font-weight: 400;
                            color: #AFB6C9;
                            line-height: 30px;
                        }
                        .el-checkbox{
                            margin-top: 10px;
                        }
                        .el-checkbox__label{
                            color: #B6BCD1;
                        }

                    }
                }
            }
        }
    }
</style>
